import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiselectItem, MultiselectSettings } from '../../../core/interfaces/admin.interface';
import { ProductService } from '../../../core/services/product.service';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'sacbo-product-threshold-select',
  templateUrl: './product-threshold-select.component.html',
  styleUrls: ['./product-threshold-select.component.scss']
})
export class ProductThresholdSelectComponent {

  @Input() set preselectedThresholds(newValue: number[]) {
    this.selectFromId(newValue);
  }

  @Input() set idProduct(newValue: number) {
    this.load(newValue);
  }

  @Input() singleSelection: boolean = null;

  @Input() disabled: boolean = false;

  @Input() thresholdsSelected: MultiselectItem[] = [];

  @Output() thresholdsSelectedChange = new EventEmitter<MultiselectItem[]>();
  @Output() onSelected = new EventEmitter<MultiselectItem[]>();

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  get computedSettings(): MultiselectSettings {
    const base = MULTI_SELECT_SETTING[EMULTI_SELECT_SETTING.MULTIPLE_SEARCH];
    if (this.singleSelection != null) {
      return { ...base, singleSelection: this.singleSelection };
    }
    return base;
  }

  list: MultiselectItem[] = [];

  preselectedIds: number[];

  constructor(
    private productService: ProductService,
  ) { }

  onElementSelect(): void {
    this.thresholdsSelectedChange.emit(this.thresholdsSelected);
    this.onSelected.emit(this.thresholdsSelected);
  }

  load(idProduct: number) {

    if (!idProduct) {
      return
    }

    this.productService.getProductById(idProduct).subscribe((response) => {

      this.list = response?.data.thresholdAttribute.map(threshold => {

        return {
          id: threshold.productThresholds?.length ? threshold.productThresholds[0].id : null,
          itemName: threshold.name
        } as MultiselectItem

      })

      if (this.preselectedIds?.length && this.thresholdsSelected.length == 0) {
        this.selectFromId(this.preselectedIds);
      }

    },
    (error) => {
      console.log("errore", error);
    });

  }

  selectFromId(ids: number[], withEvent: boolean = true) {

    this.preselectedIds = ids;

    this.thresholdsSelected = this.list.filter(c => ids?.includes(c.id));

    if (withEvent) {
      this.onElementSelect();
    }

  }

}
